import React from 'react'
import {CrossStorageHub} from 'cross-storage'
import getConfig from '../../config'
const { WEBSITE_URI } = getConfig()

const RE_URL_INFORMATION = new RegExp([
  '^(https?:)//', // protocol
  '(([^:/?#]*)(?::([0-9]+))?)' // host (hostname and port)
].join(''))

const CrossStorage = (props) => {
  if (process.env.NODE_ENV === 'test') return null
  let websiteHost = WEBSITE_URI.match(RE_URL_INFORMATION)[2]
  CrossStorageHub.init([
    {origin: new RegExp(`.*${websiteHost}$`), allow: ['get']}
  ])
  return <div>Cross storage enabled for: {websiteHost}</div>
}

export default CrossStorage



// WEBPACK FOOTER //
// ./src/pages/CrossStorage/CrossStorage.js